import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';

import { filter, map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AppConfig } from '../app.config';
import { HelpersService } from './helpers.service';
import { PartnerService } from './partner.service';
import moment from 'moment';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class PosIntegrationService {
  private apiURLZA: any;
  private apiURL: any;
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.apiURLZA = this.appConfig.getEnvironmentZA();
    this.env = this.appConfig.getEnvironmentNew();
  }

  checkPOSIntegration(PartnerID, POSSystemID) {
    var headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/POSIntegration/${PartnerID}/${POSSystemID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error);
        }),
      );
  }

  disconnectPOSIntegration(PartnerID) {
    var headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/Bikeshop/POSIntegration/${PartnerID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  disconnectPOSAuth(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    console.log('qwe', PartnerID);
    return this.http
      .delete(
        this.appConfig.getPOSEnvironment().url +
        `/${PartnerID}/disconnect`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getXeroAuthURL(data) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(
        this.apiURL + '/api/Partner/FetchXeroAuthorizeUrl',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  registerXero(data) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(this.apiURL + '/api/Partner/RegisterXero', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  launchXeroAuthPopup(url) {
    var w = window.open(
      url,
      'xeroForm',
      'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=860,height=720',
    );
    return w;
  }

  getShopifyAuthURL(data) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(
        this.apiURL + '/api/Partner/Shopify/AuthorizeUrl',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  registerShopify(data) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(
        this.apiURL + '/api/Partner/Shopify/DoRegistration',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  launchShopifyAuthPopup(url) {
    var w = window.open(
      url,
      'shopifyForm',
      'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=860,height=720',
    );
    return w;
  }

  getShopifyConfig(PartnerID) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL + `/api/Partner/${PartnerID}/ShopifyConfig`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  updateShopifyConfig(config) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(this.apiURL + `/api/Partner/ShopifyConfig`, config, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getShopifyLocations(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/ShopifyLocations`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  startPOSSync(PartnerID) {
    var partner = this.helpersService.getPartnerData();
    if (
      partner.posSystemID <= 2 ||
      partner.posSystemID == 5 ||
      partner.posSystemID == 7
    ) {
      let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

      return this.http
        .get(this.apiURL + `/api/Partner/${PartnerID}/SyncPOS`, requestOptions)
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: HttpErrorResponse) => {
            return throwError(error.error);
          }),
        );
    } else {
      var headers = this.helpersService.getPOSApiHeaders(
        this.appConfig.getPOSEnvironment().key,
      );
      return this.http
        .get(
          this.appConfig.getPOSEnvironment().url +
          `/${PartnerID}/products/sync/incremental/immediate`,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: HttpErrorResponse) => {
            return throwError(error);
          }),
        );
    }
  }

  startFullPOSSync(PartnerID, posSystemID = null) {
    if (posSystemID == null || posSystemID == undefined) {
      var partner = this.helpersService.getPartnerData();
      posSystemID = partner.posSystemID;
    }

    if (posSystemID <= 2 || posSystemID == 5 || posSystemID == 7) {
      let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

      return this.http
        .get(
          this.apiURLZA + `/api/Partner/${PartnerID}/FullPOSResync`,
          requestOptions,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: HttpErrorResponse) => {
            return throwError(error.error);
          }),
        );
    } else {
      var headers = this.helpersService.getPOSApiHeaders(
        this.appConfig.getPOSEnvironment().key,
      );
      return this.http
        .get(
          this.appConfig.getPOSEnvironment().url +
          `/${PartnerID}/products/sync/complete`,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: HttpErrorResponse) => {
            return throwError(error);
          }),
        );
    }
  }

  startPOSClientSync(partnerId: string, posSystemID = null) {
    //var partner = this.helpersService.getPartnerData();
    //if ((partner.POSSystemID <= 10 || partner.posSystemID <= 10) && (partner.POSSystemID != 9)) {
    //  let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    //  return this.http.get(this.apiURLZA + "/api/Partner/" + partnerId + "/SyncClients", requestOptions)
    //    .pipe(map((res: any) => {return res;}),
    //      catchError((res: any) => { return throwError(res.statusText) }));
    //}
    //else {

    //  var headers = this.helpersService.getPOSApiHeaders(this.appConfig.getPOSEnvironment().key);
    //  return this.http
    //    .get(this.appConfig.getPOSEnvironment().url + `/${partnerId}/customers/sync/incremental/immediate`, headers)
    //    .pipe(
    //      map((res: any) => {return res;}),
    //      catchError((error: HttpErrorResponse) => {
    //        return throwError(error);
    //      })
    //    );
    //}

    if (posSystemID == null || posSystemID == undefined) {
      var partner = this.helpersService.getPartnerData();
      posSystemID = partner.posSystemID;
    }

    if (posSystemID <= 2 || posSystemID == 5 || posSystemID == 7) {
      let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
      return this.http
        .get(
          this.apiURLZA + '/api/Partner/' + partnerId + '/SyncClients',
          requestOptions,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            return throwError(res.statusText);
          }),
        );
    } else {
      var headers = this.helpersService.getPOSApiHeaders(
        this.appConfig.getPOSEnvironment().key,
      );
      return this.http
        .get(
          this.appConfig.getPOSEnvironment().url +
          `/${partnerId}/customers/sync/complete`,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: HttpErrorResponse) => {
            return throwError(error);
          }),
        );
    }
  }

  startIncrementalPOSClientSync(partnerId: string) {
    var partner = this.helpersService.getPartnerData();
    if (
      partner.POSSystemID <= 2 ||
      partner.posSystemID == 5 ||
      partner.POSSystemID == 7
    ) {
      let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
      return this.http
        .get(
          this.apiURLZA +
          '/api/Partner/' +
          partnerId +
          '/SyncClientsIncremental',
          requestOptions,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            return throwError(res.statusText);
          }),
        );
    } else {
      var headers = this.helpersService.getPOSApiHeaders(
        this.appConfig.getPOSEnvironment().key,
      );
      return this.http
        .get(
          this.appConfig.getPOSEnvironment().url +
          `/${partnerId}/customers/sync/incremental/immediate`,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: HttpErrorResponse) => {
            return throwError(error);
          }),
        );
    }
  }

  getLightspeedAuthURL() {
    const headers = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(this.apiURL + '/api/Partner/LSGetAuthURL', headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  launchLightspeedAuthPopup(url) {
    var w = window.open(
      url,
      'lightspeedForm',
      'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=860,height=720',
    );
    return w;
  }

  registerLightspeed(data) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(this.apiURL + '/api/Partner/RegisterLS', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getLightSpeedConfig(PartnerID) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/LSConfig`, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getVendAuthURL() {
    const headers = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(this.apiURL + '/api/Partner/VendGetAuthURL', headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  launchVendAuthPopup(url) {
    var w = window.open(
      url,
      'VendForm',
      'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=1024,height=720',
    );
    return w;
  }

  registerVend(data) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(this.apiURL + '/api/Partner/RegisterVend', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  //VEND --- Configure registers, shop, tax etc
  getVendConfig(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/VendConfig`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getVendRegisters(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/VendRegisters`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getVendTaxes(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/VendTaxes`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getVendUsers(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/VendUsers`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getVendPaymentTypes(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/VendPaymentTypes`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  updateVendConfig(data) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + `/api/Partner/VendConfig`, data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  //Lightspeed --- Configure registers, shop, tax etc
  getLightspeedConfig(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/LSConfig`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getLightspeedRegisters(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/LSRegisters`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getLightspeedTaxes(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/LSTaxes`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getLightspeedShops(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/LSShops`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getLightspeedUsers(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/LSEmployees`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getLightspeedPaymentTypes(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/LSPaymentTypes`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getLightspeedVendors(PartnerID) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Partner/${PartnerID}/LSVendors`, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  updateLightspeedConfig(data) {
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + `/api/Partner/LSConfig`, data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  //Northmill
  savePOSConnection(PartnerID, data) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .post(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/authentication`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error);
        }),
      );
  }

  getOAuthUrl(PartnerID, PosID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url +
        `/${PartnerID}/authentication/url/pos/${PosID}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  //Retail Express
  getRetailExpressConfig(PartnerID) {
    //let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    //return this.http
    //  .get(this.apiURL + `/api/Partner/${PartnerID}/ShopifyConfig`, requestOptions)
    //  .pipe(
    //    map((res: any) => {return res;}),
    //    catchError((error: HttpErrorResponse) => {
    //      return throwError(error.error);
    //    })
    //  );
  }

  updateRetailExpressConfig(PartnerID, data) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );

    return this.http
      .put(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getRetailExpressLocations(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getRetailExpressPaymentTypes(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url +
        `/${PartnerID}/shops/paymentTypes`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  updateCitrusLimeConfig(PartnerID, data) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );

    return this.http
      .put(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getCitrusLimeLocations(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  //Shopify New APIs
  syncPOSNew(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url +
        `/${PartnerID}/products/sync/complete`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getShopifyStoreDetails(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  saveShopifyStoreDetails(PartnerID, data) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .post(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  updateShopifyStoreDetails(PartnerID, data) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .put(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  deleteShopifyStoreDetails(PartnerID, data) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    var options: any = {
      headers: headers,
      body: data,
    };
    return this.http
      .delete(
        this.appConfig.getPOSEnvironment().url +
        `/${PartnerID}/shops?code=` +
        this.appConfig.getPOSEnvironment().key,
        options,
      )
      .pipe
      //map((res: any) => {return res;}),
      //catchError((error: HttpErrorResponse) => {
      //  return throwError(error.error);
      //})
      ();
  }

  syncPOSPayments(partnerID, reservationID) {
    var data = {
      PartnerID: partnerID,
      ReservationID: reservationID,
    };
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Invoice/Rental/UpdatePaymentTransactionsFromPOS`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  syncNewPOSPayments(partnerID, invoiceID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .post(
        this.appConfig.getPOSEnvironment().url +
        `/${partnerID}/rentals/invoices/${invoiceID}/payments`,
        {},
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  syncLongTermPOSPayments(partnerID, reservationID) {
    var data = {
      PartnerID: partnerID,
      ReservationID: reservationID,
    };
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Invoice/Rental/SyncLongTermRentalPayments`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  syncWorkshopPOSPayments(partnerID, serviceID) {
    var data = {
      PartnerID: partnerID,
      ServiceID: serviceID,
    };
    const headers = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/Invoice/Service/UpdatePaymentTransactionsFromPOS`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  syncNewWorkshopPOSPayments(partnerID, invoiceID) {
    var data = {};
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .post(
        this.appConfig.getPOSEnvironment().url +
        `/${partnerID}/invoices/${invoiceID}/payments`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getLocations(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getPriceLevels(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops/priceLevels`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getTaxes(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops/taxes`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  updateConfig(PartnerID, data) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .put(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getConfig(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops/config`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getUsers(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops/staff`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getPaymentDevices(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops/devices`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  updatePaymentDevice(PartnerID, data) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .post(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops/devices`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  ProcessCallbacks(PartnerID, code, posname) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url +
        `/${PartnerID}/authentication/url/callback?code=${code}&pos=${posname}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  ProcessHeartlandsCallback(PartnerID, code) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url +
        `/auth/heartlands/callback?code=${code}&partner=${PartnerID}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  getPartnerPOSSyncStatus(PartnerID) {
    var headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${PartnerID}/POSSyncSummary?code=${this.env.key}&LocalTime=${moment().format("yyyy-MM-DDTHH:mm:ss")}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error);
        }),
      );
  }


  getPartnerCustomerSyncStatusStream(partnerId: string): Observable<string> {
    return new Observable<string>((observer) => {
      const url = `${this.env.url}/Bikeshop/${partnerId}/GetPartnerCustomerCounts?code=${this.env.key}&LocalTime=${moment().format("yyyy-MM-DDTHH:mm:ss")}`;

      fetch(url, {
        method: 'GET',
        headers: this.helpersService.getNewApiHeaders().headers,
      })
        .then((response) => {
          const reader = response.body?.getReader();
          const decoder = new TextDecoder();

          const readChunk = async () => {
            if (!reader) {
              observer.error('No response body');
              return;
            }

            while (true) {
              const { done, value } = await reader.read();
              if (done) break;

              const chunk = decoder.decode(value, { stream: true });
              observer.next(chunk); // Emit each chunk
            }

            observer.complete(); // End of stream
          };

          readChunk();
        })
        .catch((err) => {
          observer.error(err);
        });
    });
  }


   getPartnerPOSConfiguration(PartnerID) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key, PartnerID, PartnerID
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/partner/pos/configuration`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }


  getTaxOverrides(PartnerID: string) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops/taxRateOverrides`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  createTaxOverrides(PartnerID: string, data: any) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .post(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops/taxRateOverrides`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  updateTaxOverrides(PartnerID: string, data: any) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .put(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops/taxRateOverrides`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }

  deleteTaxOverrides(PartnerID: string, data: any) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .delete(
        this.appConfig.getPOSEnvironment().url + `/${PartnerID}/shops/taxRateOverrides/${data}`,
        headers
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error);
        }),
      );
  }
}
